import React from 'react';
import { FaDiscord } from 'react-icons/fa';

interface UserStatusProps {
  status: string;
  avatar: string;
  username: string;
  customStatus?: string;
  discordId: string;
}

const UserStatus: React.FC<UserStatusProps> = ({ status, avatar, username, customStatus, discordId }) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'online':
        return 'bg-green-600';
      case 'idle':
        return 'bg-yellow-500';
      case 'dnd':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className="flex sm:flex-row flex-col gap-4 sm:items-center justify-between w-full">
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-row relative">
          <img
            draggable="false"
            className="h-[4.5rem] w-[4.5rem] min-w-[4.5rem] min-h-[4.5rem] rounded-xl"
            src={avatar}
            alt="User Avatar"
            style={{
              borderColor: 'rgb(255, 255, 255)',
              borderWidth: '2px',
            }}
          />
          <div className={`absolute ${getStatusColor(status)} w-4 h-4 rounded-full translate-x-16 translate-y-[3.75rem] z-10`} />
        </div>
        <div className="flex flex-col">
          <div className="flex flex-col gap-1">
            <div className="flex flex-row gap-1">
              <h2 className="font-semibold break-all text-white">@{username}</h2>
              <DiscordBadges />
            </div>
            <div className="flex flex-row gap-1">
              <p className="text-sm break-all text-white">{customStatus || status}</p>
            </div>
          </div>
        </div>
      </div>
      <a
        href={`https://discord.com/users/${discordId}`}
        target="_blank"
        rel="noopener noreferrer"
        className="p-1.5 pl-3 duration-300 flex hover:brightness-125 sm:w-fit w-full justify-center items-center text-sm font-semibold group whitespace-nowrap rounded-xl bg-[rgba(33,33,33,0.9)] text-white border-2 border-white"
      >
        Add on Discord
        <FaDiscord className="w-7 h-7 group-hover:translate-x-1 duration-300 ml-1" />
      </a>
    </div>
  );
};

const DiscordBadges: React.FC = () => {
  return (
    <div className="flex flex-row flex-wrap">
      <DiscordBadge icon="🏆" tooltip="HypeSquad Brilliance" />
      <DiscordBadge icon="💎" tooltip="Discord Nitro" />
    </div>
  );
};

const DiscordBadge: React.FC<{ icon: string; tooltip: string }> = ({ icon, tooltip }) => {
  return (
    <div className="group relative flex flex-col items-center justify-center">
      <span className="text-2xl">{icon}</span>
      <div className="absolute p-1 translate-y-2 z-10 scale-0 group-hover:scale-100 group-hover:translate-y-[2rem] duration-300 transform-gpu whitespace-nowrap bg-zinc-800 text-white text-xs rounded-md">
        {tooltip}
      </div>
    </div>
  );
};

export default UserStatus;